"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'CustomImageViewer',
  props: {
    urlList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    onClose: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      index: this.initialIndex,
      isLoading: true,
      loadError: false,
      imgStyle: {
        transform: 'scale(1) rotate(0deg)'
      }
    };
  },
  methods: {
    hide: function hide() {
      this.onClose();
    },
    handleImgLoad: function handleImgLoad() {
      this.isLoading = false;
    },
    handleImgError: function handleImgError() {
      this.isLoading = false;
      this.loadError = true;
    }
  }
};